<div class="container-fluid px-0" style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="heading-top d-flex">
        <div class="pt-1 ml-3 sm-22">
            <!-- <i class="fas fa-home pt-1 mr-2 color-blue"></i> -->
            <svg class="pt-2 mr-3" width="18" height="29" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.848 16.498C15.2076 16.4969 15.4989 16.2056 15.5 15.846V7.49799C15.4885 7.29437 15.3984 7.10317 15.2487 6.96465L8 1.49799L0.751333 6.96465C0.601642 7.10317 0.51154 7.29437 0.5 7.49799V15.846C0.501098 16.2056 0.792366 16.4969 1.152 16.498H14.848Z" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="gilroy-bold color-royalblue">KYC</span>
        </div>
    </div>
    <div class="container document-form px-0 ml-0">
        <div class="row head-top">  
            <div class="col-12 col-md-8">    
                <h6 *ngIf="uploadedDocs.length==0 && auth.user.verified==0" class="sm-16 font-weight-bold primary-text">
                    Upload your identity documents
                </h6>
                <h6 *ngIf="uploadedDocs.length!=0 && requiredDocs.length>0 && auth.user.verified==0" class="sm-16 font-weight-bold primary-text">
                    View your identity documents
                </h6>
                <h6 *ngIf="requiredDocs.length>0 && auth.user.verified==1" class="sm-16 font-weight-bold primary-text">Your document has been verified successfully</h6>
                
                <small *ngIf="uploadedDocs.length==0 && requiredDocs.length>0 && auth.user.verified==0" class="sm-12  mobile16 secondary-text">
                    Please select an identity document type you will use to verify yourself.
                </small>
                <!--Listing -->
                <div class="card mt-4 border-0 box-shadows" *ngFor="let item of uploadedDocs">
                    <div class="card-body">
                        <div class="row">  
                            <div class="col-md-8 col-sm-10" ><h5 class=" sm-16">{{item.document_name[0].toUpperCase() + item.document_name.substr(1, item.document_name.length)}}</h5>
                            </div>
                            <div class="col-md-4 col-sm-2"><!-- <img  [src]="item.document_path"> --></div>
                        </div>
                        <a target="_blank" [href]="item.path">
                            <small class="custom-text-font text-secondary ">
                                {{item.file_name}}
                            </small>
                        </a>
                    </div>
                </div>
                <!--Upload docoument form -->
                <ng-container *ngIf="requiredDocs.length>0 && auth.user.verified==0">
                    <!-- <h6 class="sm-14 font-weight-bold pt-4">Upload document<small class="sm-10 grey-text pl-2">(PDF/JPG/PNG formate only)</small></h6> -->
                    <form class="pt-3" enctype="multipart/form-data" #documentForm="ngForm" (ngSubmit)="onDocumentFormSubmit(documentForm)">
                        <div class="col-12 m-0 p-0" *ngIf="uploadedDocs.length == 0">
                            <div class="form-group">
                                <label for="idNumber">Document ID number</label>
                                <input type="text" name="sender_id_number" ngModel
                                class=" p-3 w-100 sm-12 mobile16 border-0 outline-none" data-pr-form="idNumber"
                                id="idNumber" placeholder="Sender id number" 
                                required>
                            </div>
                        </div>
                        <div class="form-group " *ngIf="uploadedDocs.length == 0">
                            <label for="document_type_id">Document type</label>

                            <select (change)="onTypeChange($event.target.value)" class="form-control border-0 box-shadows " name="document_type_id" ngModel required>
                                <option value="" selected> Select document type </option>
                                <option class="" [value]="item.id" *ngFor="let item of requiredDocs">{{item.document_name[0].toUpperCase() + item.document_name.substr(1, item.document_name.length)}}</option>
                            </select>
                        </div>
                        <small class="secondary-text mobile16 sm-12"  *ngIf="uploadedDocs.length == 0">
                            <!-- Please upload an image of your document.<br> -->
                            (PDF, jpeg or png up to 5 mb accepted) 
                        </small>
                        <ng-container  *ngIf="selectedType">
                            <div class="form-group document-upload" *ngFor="let filename of selectedType?.requiredFiles">
                                <div class="file btn border uplaod-doc box-shadows w-100 p-5 sm-16 font-weight-bold">
                                    <span class="d-block">
                                        <img src="assets/images/upload-file.PNG" alt="Upload Document"  style="width: 30px;">
                                    </span> 
                                    <span > 
                                        {{ files[filename]?.name?files[filename]?.name:"Choose file"}}
                                    </span>
                                    <input (change)="onFileChanged(filename,$event)" class="fileupload" type="file" [name]="filename" ngModel required accept="application/pdf, image/jpeg, image/png, image/jpg">
                                </div>
                            </div>
                            <!-- <div class="form-group" *ngFor="let filename of selectedType?.requiredFiles">
                                <input (change)="onFileChanged(filename,$event)" class="fileupload" type="file" [name]="filename" ngModel required>
                            </div> -->
                            <div class="sm-10 text-danger" *ngIf="!canUpload">Please upload file of less than 5 mb.</div>
                            <div class="d-flex  mt-3 flexToBlock address_field">
                                <a style="cursor: pointer;" (click)="cancelUpload(documentForm)" type="button" class="link sm-12 back-btn pt-2 d-flex align-items-center justify-content-center">Cancel</a>
                                <button [disabled]="!documentForm.valid || !canUpload" class="btn btn-primary btn-widthFull w-100" type="submit">Upload</button>
                            </div>
                        </ng-container>
                    </form>
                </ng-container>
                <div class="d-flex justify-content-around address_field mt-4">
                    <!-- <button *ngIf="auth.user.country_id==233" [disabled]="!state.value" (click)="goTo('phone')" type="button" class="btn primary-btn w-100 sm-12 h-auto">Next</button> -->
                    
                    <button *ngIf="uploadedDocs.length>0 && auth.user.verified==0"   [routerLink]="['/dashboard']" routerLinkActive="router-link-active"  type="button" class="btn  primary-btn sm-12 h-auto w-100 btn-widthFull">Done</button>
                </div>
                <!--Upload docoument form -->
            </div>
        </div>
    </div>
</div>
